<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h11">Acknowledgments</h1>
<p class="p6"> </p>
<p class="p6"> </p>
<p class="p6">Special thanks to theater director and playwright Jeremy Cole for his intrepid dedication and guidance on ongoing drafts of this novel; to novelist Chris Kenry for his encouragement and suggestions; to George Ware, Kristen Hannum, John Serini, and the late, great Jack Long for invaluable feedback; to Peter Knapp and Bruce Morgan for specific revision advice.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?53db6570